export class AppEnvironmentUtil {
  static getName(): string {
    return process.env.APP_ENV || 'development';
  }

    static isDevelopment(): boolean {
        return (
            ['sandbox', 'ecomm-dev', 'ecomm-acc', 'development'].indexOf(
                this.getName().toLowerCase()
            ) >= 0
        );
    }

  static isProduction(): boolean {
    return ['production', 'ecomm-prd'].indexOf(this.getName().toLowerCase()) >= 0;
  }
}
